import { makeStyles } from '@mui/styles'; // https://stackoverflow.com/questions/72495622/npm-install-of-mui-styles-is-not-working-for-react-18

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: "flex",
    alignItems: "center",
    marginBottom: 24,
    width: "100%",
    justifyContent: "flex-end",
  },
  body: {
    // width: '95vw',
    height: '100vh',
    position: "relative",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 50,
    margin: "auto"
  },
  drawerPaper: {
    '@media print': {
      position: 'static !important',
      height: 'auto !important',
      width: 'auto !important',
      maxHeight: 'none !important',
      zIndex: 'auto !important',
      overflow: 'visible !important',
    },
  },
  drawerContent: {
    width: '95vw',
    height: '100vh',
    position: "relative",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    margin: "auto",
    '@media print': {
      width: 'auto !important',
      height: 'auto !important',
      position: 'static !important',
      paddingTop: '0 !important',
      margin: '0 !important',
    },
  },

}));

export default useStyles;